import { render, staticRenderFns } from "./ApplicantType.vue?vue&type=template&id=e45a4dba&scoped=true&"
import script from "./ApplicantType.vue?vue&type=script&lang=js&"
export * from "./ApplicantType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45a4dba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition,VSlideYTransition})
